'use client';
import React from 'react';
import {usePathname} from 'next/navigation';
import {
  getCurrentLanguage,
  languageChange,
  updateLocaleInDOM,
} from '@utils/translate.utils';
import {LanguageTypes} from './LetzChat.type';

export function LetzChat() {
  const pathname = usePathname();

  // const onLoad = (e: any) => {
  // };
  // const onReady = () => {
  // };
  // const onError = (e: any) => {};

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const lang = getCurrentLanguage() as LanguageTypes;
    const langChange = languageChange(lang);
    updateLocaleInDOM(lang);
  }, [pathname]);

  return null;

  // return (
  //   <Script
  //     id='letzchat-script'
  //     src={LetzChatUrl}
  //     onLoad={onLoad}
  //     onReady={onReady}
  //     onError={onError}
  //   />
  // );
}
